import {
  updateOrganizationCancelationTypes,
  updateReviewMandatoryTypes,
  updateSurveySkippableTypes,
  updateServiceFeeTypes,
  updateCommissionStructureTypes,
  updateSupportTypes,
  updateOrganizationSplitChargeTypes,
  organizationStripeLoginLinkTypes,
} from './action_types';

import {
  UPDATE_ORGANIZATION_CANCELATION_MUTATION,
  UPDATE_REVIEW_MANDATORY_MUTATION,
  UPDATE_SURVEY_SKIPPABLE_MUTATION,
  UPDATE_SERVICE_FEE_MUTATION,
  UPDATE_COMMISSION_STRUCTURE_MUTATION,
  UPDATE_SUPPORT_MUTATION,
  UPDATE_ORGANIZATION_SPLIT_CHARGE_MUTATION,
  ORGANIZATION_STRIPE_LOGIN_LINK_QUERY,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const updateOrganizationCancelation = variables => makeMutation({ variables })(
  updateOrganizationCancelationTypes,
  UPDATE_ORGANIZATION_CANCELATION_MUTATION
);

export const updateReviewMandatory = variables => makeMutation({ variables })(
  updateReviewMandatoryTypes,
  UPDATE_REVIEW_MANDATORY_MUTATION
)

export const updateSurveySkippable = variables => makeMutation({ variables })(
  updateSurveySkippableTypes,
  UPDATE_SURVEY_SKIPPABLE_MUTATION
);

export const updateServiceFee = variables => makeMutation({ variables })(
  updateServiceFeeTypes,
  UPDATE_SERVICE_FEE_MUTATION
);

export const updateCommissionStructure = variables => makeMutation({ variables })(
  updateCommissionStructureTypes,
  UPDATE_COMMISSION_STRUCTURE_MUTATION
);

export const updateSupport = variables => makeMutation({ variables })(
  updateSupportTypes,
  UPDATE_SUPPORT_MUTATION
);

export const updateOrganizationSplitCharge = variables => makeMutation({ variables })(
  updateOrganizationSplitChargeTypes,
  UPDATE_ORGANIZATION_SPLIT_CHARGE_MUTATION,
);

export const organizationStripeLoginLink = variables => makeQuery(variables)(
  organizationStripeLoginLinkTypes,
  ORGANIZATION_STRIPE_LOGIN_LINK_QUERY,
)



// WEBPACK FOOTER //
// ./src/modules/organization/actions.js